import React, { useEffect } from 'react';
import { Col, Row } from '../../../styles';
import { GenerateFieldRevamped, TwoFilesUpload } from '@Components';
import CommonButton from '../../../../../components/common-button/CommonButton';
import { Heading, PassportContainer, RowWrapper } from './Style';
import { PassportUploadComponentProps } from '../../../utils/interface';
import { reduxForm, change } from 'redux-form';
import { scrollToError } from '@Redux/actions/ui-trigger';
import { showMessage } from '@Redux/actions/common-message';
import { PASSPORT_FORM, UPLOAD_DOCUMENT_SCREEN } from '../../../utils/constants';
import { isEmpty } from 'lodash';
import { IUploadFiles } from '../../../../user-flow/individual/revampedUserFlow/Interfaces/interface';
import { FileUploadTextContainer } from '../../../../user-flow/individual/revampedUserFlow/manualDocumentUpload/styles';
import COLORS from '../../../../../common/styles/color-pallete';
import { openSampleModal } from '../../../../user-flow/individual/revampedUserFlow/idVerificationFailure/PassportSampleModal';
import { IN } from '@Utils/constants';

type CombinedProps = PassportUploadComponentProps & IUploadFiles;

const PassportUploadComponent = (props: CombinedProps): React.ReactElement => {
  const {
    data,
    handleDocumentUpload,
    dispatch,
    fileBackUploadInputRef,
    fileFrontUploadInputRef,
    frontFilesBase,
    setFrontFilesBase,
    backFilesBase,
    setBackFilesBase,
    frontFiles,
    setFrontFiles,
    backFiles,
    setBackFiles,
    fileErrors,
    setFilesError,
    isNiumForexUser,
    defaultValue,
    fileSizeLimit
  } = props;

  useEffect(() => {
    dispatch(change(PASSPORT_FORM, 'issuing_country', IN));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = () => {
    handleDocumentUpload(data?.document_code, data?.document_input_type);
  };

  //Edge case if field_json is empty object, page should not break
  if (isEmpty(data?.fields_json)) {
    dispatch(showMessage({ text: ['Something went wrong'], type: 'info' }));
    return <></>;
  }

  return (
    <PassportContainer>
      <form onSubmit={props.handleSubmit(onSubmit)}>
        <Heading>{data.label}</Heading>
        <RowWrapper>
          {data?.fields_json?.map((subField: any, subIndex: number) => (
            <Row padding={[13, 0]} key={'subFields' + subIndex}>
              <Col width={450}>
                <GenerateFieldRevamped
                  field={subField}
                  dropDownDefaultValue={defaultValue}
                  isNiumForexUser={isNiumForexUser}
                />
              </Col>
            </Row>
          ))}
        </RowWrapper>
        <div className="passport-wrapper">
          <>
            <TwoFilesUpload
              label={'Upload passport copy'}
              fileFrontUploadInputRef={fileFrontUploadInputRef}
              fileBackUploadInputRef={fileBackUploadInputRef}
              setFilesError={setFilesError}
              frontFiles={frontFiles}
              backFiles={backFiles}
              frontFilesBase={frontFilesBase}
              backFilesBase={backFilesBase}
              setFrontFiles={setFrontFiles}
              setBackFiles={setBackFiles}
              setFrontFilesBase={setFrontFilesBase}
              setBackFilesBase={setBackFilesBase}
              fileErrors={fileErrors}
              isBackRequired={data?.is_back_required}
              isNiumForexUser={isNiumForexUser}
              fileSizeLimit={fileSizeLimit}
            />
            <Row padding={[16, 0, 0, 0]}>
              <Col width={450}>
                <FileUploadTextContainer
                  cursor={true}
                  headerMarginTop={8}
                  textColor={COLORS.darkBlue}
                  fontWeight={700}
                >
                  <span className="__description">
                    {`Open personal details section and capture both pages clearly.`}
                  </span>
                  <span className="__heading" onClick={() => openSampleModal()}>
                    {`View sample`}
                  </span>
                </FileUploadTextContainer>
              </Col>
            </Row>
          </>
        </div>
        <Row padding={[48, 0, 24, 0]}>
          <Col width={450}>
            <CommonButton text={UPLOAD_DOCUMENT_SCREEN.passport.submit} width={450} id="submit" />
          </Col>
        </Row>
      </form>
    </PassportContainer>
  );
};

const createReduxForm = reduxForm({
  form: PASSPORT_FORM,
  onSubmitFail: scrollToError
});

const PassportUploadForm = createReduxForm(PassportUploadComponent);

export default PassportUploadForm;
